export default __webpack_public_path__ + "static/media/storageUnit1-afterC-480w.38ec3598.avif";